import * as React from 'react';
import { chipClasses } from '@mui/material/Chip';
import { chipColors } from '../colors';
import { XCircle as XCircleIcon } from '@phosphor-icons/react/dist/ssr/XCircle';
import { logger } from '@/lib/default-logger';

// logger.debug('red chip', chipColors['red'][50]);

function getSoftVars_old(color, dark) {
  // logger.debug('soft called', color);
  return null;
  if (dark) {
    return {
      '--Chip-softBg': `var(--mui-palette-${color}-800)`,
      '--Chip-softColor': `var(--mui-palette-${color}-200)`,
      '--Chip-softDisabledBg': `var(--mui-palette-${color}-800)`,
      '--Chip-softDisabledColor': `var(--mui-palette-${color}-500)`,
      '--Chip-softHoverBg': `var(--mui-palette-${color}-700)`,
      '--Chip-softDeleteIconColor': `var(--mui-palette-${color}-200)`,
      '--Chip-softDeleteIconHoverColor': `var(--mui-palette-${color}-50)`,
    };
  }

  return {
    '--Chip-softBg': `var(--mui-palette-${color}-100)`,
    '--Chip-softColor': `var(--mui-palette-${color}-700)`,
    '--Chip-softDisabledBg': `var(--mui-palette-${color}-50)`,
    '--Chip-softDisabledColor': `var(--mui-palette-${color}-400)`,
    '--Chip-softHoverBg': `var(--mui-palette-${color}-200)`,
    '--Chip-softDeleteIconColor': `var(--mui-palette-${color}-700)`,
    '--Chip-softDeleteIconHoverColor': `var(--mui-palette-${color}-800)`,
  };
}

function getSoftVars(color, dark) {
  // logger.debug('soft called', color, dark, chipColors[color]);
  if (!chipColors[color]) return null;
  if (dark) {
    return {
      '--Chip-softBg': chipColors[`${color}`][800],
      '--Chip-softColor': chipColors[`${color}`][100],
      '--Chip-softDisabledBg': chipColors[`${color}`][800],
      '--Chip-softDisabledColor': chipColors[`${color}`][500],
      '--Chip-softHoverBg': chipColors[`${color}`][700],
      '--Chip-softDeleteIconColor': chipColors[`${color}`][200],
      '--Chip-softDeleteIconHoverColor': chipColors[`${color}`][50],
    };
  }

  return {
    '--Chip-softBg': chipColors[`${color}`][100],
    '--Chip-softColor': chipColors[`${color}`][700],
    '--Chip-softDisabledBg': chipColors[`${color}`][50],
    '--Chip-softDisabledColor': chipColors[`${color}`][400],
    '--Chip-softHoverBg': chipColors[`${color}`][200],
    '--Chip-softDeleteIconColor': chipColors[`${color}`][700],
    '--Chip-softDeleteIconHoverColor': chipColors[`${color}`][800],
  };
}

export const MuiChip = {
  defaultProps: {
    color: 'secondary', // default will be removed in material v6
    deleteIcon: <XCircleIcon />,
  },
  styleOverrides: {
    // root: { borderRadius: '10px', fontWeight: 500},
    root: { borderRadius: '10px',  fontWeight: 500, height: '26px', margin: '0px' },
    outlinedSecondary: ({ theme }) => {
      // Custom case for secondary, the rest is handled by the theme

      if (theme.palette.mode === 'dark') {
        return { borderColor: 'var(--mui-palette-secondary-700)', color: 'var(--mui-palette-secondary-50)' };
      }

      return { borderColor: 'var(--mui-palette-secondary-200)', color: 'var(--mui-palette-secondary-900)' };
    },
    soft: ({ ownerState }) => {
      // logger.debug('state, color', ownerState);
      return {
        backgroundColor: 'var(--Chip-softBg)',
        // backgroundColor: theme.palette.mode === 'dark' ? chipColors[color][800] : chipColors[color][100],
        color: 'var(--Chip-softColor)',
        ...(ownerState.disabled && {
          backgroundColor: 'var(--Chip-softDisabledBg)',
          color: 'var(--Chip-softDisabledColor)',
        }),
        ...(ownerState.clickable && { '&:hover': { backgroundColor: 'var(--Chip-softHoverBg)' } }),
        [`& .${chipClasses.deleteIcon}`]: {
          color: 'var(--Chip-softDeleteIconColor)',
          '&:hover': { color: 'var(--Chip-softDeleteIconHoverColor)' },
        },
        '&.Mui-focusVisible': { backgroundColor: 'var(--Chip-softHoverBg)' },
      };
    },
    softPrimary: ({ theme }) => {
      return getSoftVars('primary', theme.palette.mode === 'dark');
    },
    softSecondary: ({ theme }) => {
      return getSoftVars('secondary', theme.palette.mode === 'dark');
    },
    softSuccess: ({ theme }) => {
      return getSoftVars('success', theme.palette.mode === 'dark');
    },
    softInfo: ({ theme }) => {
      return getSoftVars('info', theme.palette.mode === 'dark');
    },
    softWarning: ({ theme }) => {
      return getSoftVars('warning', theme.palette.mode === 'dark');
    },
    softError: ({ theme }) => {
      return getSoftVars('error', theme.palette.mode === 'dark');
    },
    softRed: ({ theme }) => {
      return getSoftVars('red', theme.palette.mode === 'dark');
    },
    softYellow: ({ theme }) => {
      return getSoftVars('yellow', theme.palette.mode === 'dark');
    },
    softOrange: ({ theme }) => {
      return getSoftVars('orange', theme.palette.mode === 'dark');
    },
    softGreen: ({ theme }) => {
      return getSoftVars('green', theme.palette.mode === 'dark');
    },
    softBlue: ({ theme }) => {
      return getSoftVars('blue', theme.palette.mode === 'dark');
    },
    softPurple: ({ theme }) => {
      return getSoftVars('purple', theme.palette.mode === 'dark');
    },
    softPink: ({ theme }) => {
      return getSoftVars('pink', theme.palette.mode === 'dark');
    },
    softGray: ({ theme }) => {
      return getSoftVars('gray', theme.palette.mode === 'dark');
    },
    softGrey: ({ theme }) => {
      return getSoftVars('grey', theme.palette.mode === 'dark');
    },
    
    iconSmall: { fontSize: 'var(--icon-fontSize-sm)' },
    iconMedium: { fontSize: 'var(--icon-fontSize-md)' },
  },
};
